import { render } from "./LawyerPage.vue?vue&type=template&id=5bffdee7&scoped=true"
import script from "./LawyerPage.vue?vue&type=script&lang=js"
export * from "./LawyerPage.vue?vue&type=script&lang=js"

import "./LawyerPage.vue?vue&type=style&index=0&id=5bffdee7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bffdee7"]])

export default __exports__